module.exports = __webpack_public_path__ + "img/7.4573b2cb.jpg";